"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HeadingSize = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["type", "children", "className", "inlineStyles", "underline", "id"];
var HeadingSize;
exports.HeadingSize = HeadingSize;

(function (HeadingSize) {
  HeadingSize["megasmalldivider"] = "megasmalldivider";
  HeadingSize["extrasmall"] = "extrasmall";
  HeadingSize["small"] = "small";
  HeadingSize["medium"] = "medium";
  HeadingSize["large"] = "large";
  HeadingSize["extralarge"] = "extralarge";
})(HeadingSize || (exports.HeadingSize = HeadingSize = {}));

var Heading = function Heading(_ref) {
  var _HeadingSize$megasmal;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? HeadingSize.large : _ref$type,
      children = _ref.children,
      className = _ref.className,
      inlineStyles = _ref.inlineStyles,
      _ref$underline = _ref.underline,
      underline = _ref$underline === void 0 ? false : _ref$underline,
      id = _ref.id,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var Component = (_HeadingSize$megasmal = {}, (0, _defineProperty2.default)(_HeadingSize$megasmal, HeadingSize.megasmalldivider, 'h5'), (0, _defineProperty2.default)(_HeadingSize$megasmal, HeadingSize.extrasmall, 'h4'), (0, _defineProperty2.default)(_HeadingSize$megasmal, HeadingSize.small, 'h3'), (0, _defineProperty2.default)(_HeadingSize$megasmal, HeadingSize.medium, 'h2'), (0, _defineProperty2.default)(_HeadingSize$megasmal, HeadingSize.large, 'h1'), (0, _defineProperty2.default)(_HeadingSize$megasmal, HeadingSize.extralarge, 'h1'), _HeadingSize$megasmal)[type];
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(_indexModule.default[type], className),
    style: inlineStyles,
    id: id
  }, props), /*#__PURE__*/_react.default.createElement("span", {
    className: underline ? _indexModule.default.underline : undefined
  }, children));
};

Heading.propTypes = {
  type: _propTypes.default.any,
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  children: _propTypes.default.node,
  underline: _propTypes.default.bool
};
var _default = Heading;
exports.default = _default;